"use client"

import { useState } from "react"
import { useLanguage } from "../../context/LanguageContext"
import { MessageCircle, QrCode, ExternalLink } from "lucide-react"

const WhatsAppCommunity = () => {
  const { t } = useLanguage()
  const [showQR, setShowQR] = useState(false)

  // Replace with your actual WhatsApp group link
  const whatsappGroupLink = "https://chat.whatsapp.com/your-group-invite-link"

  const handleJoinGroup = () => {
    window.open(whatsappGroupLink, "_blank")
  }

  return (
    <div className="bg-green-50 rounded-lg p-6 border border-green-200">
      <div className="flex items-center mb-4">
        <MessageCircle className="h-8 w-8 text-green-600 mr-3" />
        <div>
          <h3 className="text-lg font-semibold text-gray-900">{t("dashboard.joinWhatsApp")}</h3>
          <p className="text-sm text-gray-600">{t("dashboard.whatsAppDesc")}</p>
        </div>
      </div>

      <div className="space-y-4">
        {/* QR Code Section */}
        <div className="text-center">
          <button
            onClick={() => setShowQR(!showQR)}
            className="inline-flex items-center px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
          >
            <QrCode className="mr-2 h-4 w-4" />
            {showQR ? "Hide QR Code" : t("dashboard.scanQR")}
          </button>
        </div>

        {showQR && (
          <div className="flex justify-center">
            <div className="bg-white p-4 rounded-lg shadow-md">
              <img
                src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(
                  whatsappGroupLink
                )}`}
                alt="WhatsApp QR Code"
                className="w-[200px] h-[200px]"
              />
            </div>
          </div>
        )}

        {/* Direct Link */}
        <div className="text-center">
          <p className="text-sm text-gray-600 mb-2">{t("dashboard.orClickLink")}</p>
          <button
            onClick={handleJoinGroup}
            className="inline-flex items-center px-6 py-3 bg-green-600 text-white font-medium rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
          >
            <MessageCircle className="mr-2 h-5 w-5" />
            {t("dashboard.joinGroup")}
            <ExternalLink className="ml-2 h-4 w-4" />
          </button>
        </div>

        {/* Group Info */}
        <div className="bg-white rounded-md p-4 border border-green-200">
          <h4 className="font-medium text-gray-900 mb-2">Group Benefits:</h4>
          <ul className="text-sm text-gray-600 space-y-1">
            <li>• Get instant updates about donations</li>
            <li>• Connect with other donors</li>
            <li>• Receive exclusive content</li>
            <li>• Participate in community discussions</li>
            <li>• Get notified about special events</li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default WhatsAppCommunity
